import React, { useEffect, useMemo, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import styled from "styled-components";

import PCContainer from "../../components/atoms/layout/pcContainer";
import LSRgDisplay02 from "../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import LSRgH2HeadLine from "./../../components/molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import Pagination from "../../components/molecules/pagination";
import LSRgBody01 from "./../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import MOContainer from "../../components/atoms/layout/moContainer";
import SelectBox from "../../components/organisms/SelectBox";
import LSBdH2HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH2HeadLine";
import LSRgCaption01 from "./../../components/molecules/text/linSeedKr/Rg/lsRgCaption01";
import LSRgCaption02 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption02";

import { route } from "./../../router/route";
import useDisplay from "../../hooks/useDisplay";

import { consultingTabList } from "../../constant/consultingTabList";
import ConsultingApi from "../../api/consulting.api";
import { errorHandler } from "../../util/errorHandler";
import Empty from "../../components/molecules/empty";
import { fileUrl } from "../../api/api";
import { formatNumberWithCommas } from "../../util/formatNumber";
import { toast } from "react-toastify";
import LectureApi from "../../api/lecture.api";
import StyledCategoryItem from "../../components/molecules/button/styledCategoryItem";
import { macOSCheck } from "../../util/macOSCheck";
import Loading from "../../components/templates/loading";

const ConsultingApply = () => {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const location = useLocation();

  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars

  const [subMenuBoxOpen, setSubMenuBoxOpen] = useState(false);
  const [selectedSubMenu, setSelectedSubMenu] = useState(
    consultingTabList[2].title,
  );

  const [applyList, setApplyList] = useState([]);
  const [consultingTab, setIsConsultingTab] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const page = useMemo(() => {
    const requestedPage = Number(searchParams.get("page"));
    return Number.isInteger(requestedPage) && requestedPage > 0
      ? requestedPage
      : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 6, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("로그인을 해주세요.");
      navigate(`${route.login}`, {
        replace: true,
        state: { path: window.location.href },
      });
      return;
    } else {
      consultingListFunc();
    }
  }, []);

  const consultingListFunc = async () => {
    try {
      const data = {
        page: 1,
        size: 1,
        lectureVideoFlag: "Inactive",
      };
      const response = (await LectureApi.getMemberList(data)).data.data.content;

      if (response && response.length > 0) {
        setIsConsultingTab(consultingTabList);
      } else {
        setIsConsultingTab([
          { title: "1:1 컨설팅이란?", path: route.consulting },
          { title: "사전 상담 받기", path: route.consulting_prior },
          { title: "신청하기", path: route.consulting_apply },
        ]);
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") return;
    dataListFunc();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  const dataListFunc = async () => {
    setIsLoading(true);
    try {
      const data = {
        page: page,
        size: pagination.size,
        activation: "Active",
      };

      const response = (await ConsultingApi.getList(data)).data.data;

      setApplyList(response.content ?? []);
      setPagination((prev) => ({
        ...prev,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / prev.size),
      }));
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <HomeSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            width: "100%",
            padding: isSmall ? "0px 20px" : "0px",
          }}
        >
          <LSRgDisplay02
            style={{
              marginBottom: 32,
            }}
          >
            📋 1:1 컨설팅
          </LSRgDisplay02>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "fit-content",
              gap: 30,
            }}
          >
            {/* 탭 영역 */}
            <TabContainer>
              {consultingTab.map((tab, index) => (
                <StyledCategoryItem
                  key={index}
                  onClick={() => navigate(tab.path)}
                  isActive={index === 2 ? true : false}
                  title={tab.title}
                />
              ))}
            </TabContainer>
            {/* 본문 영역 */}
            <ContentContainer>
              <ContentHeaderWrapper>
                <LSRgDisplay02 style={{ color: "#101113" }}>
                  신청하기
                </LSRgDisplay02>
              </ContentHeaderWrapper>
              <BannerContainer>
                <img
                  src="/assets/images/consulting05.png"
                  alt="사전 상담 바로가기 배너 이미지"
                  style={{
                    width: 995,
                    height: 210,
                  }}
                />
                <BannerContentWrapper>
                  <BannerTextWrapper>
                    <LSBdDisplay02 style={{ color: "#fff" }}>
                      사전 상담 받고 더 확실한 컨설팅을 받아보세요!
                    </LSBdDisplay02>
                    <LSRgH2HeadLine style={{ color: "#EDEDFF" }}>
                      사전 상담을 통해 1:1 컨설팅 상품을 추천받고,
                      <br />
                      나에게 꼭 맞는 컨설팅 상품을 수강해 보세요.
                    </LSRgH2HeadLine>
                  </BannerTextWrapper>
                  <BannerButton>
                    <LSRgBody01
                      style={{ marginTop: macOSCheck() ? 0 : 4 }}
                      onClick={() => navigate(route.consulting_prior)}
                    >
                      사전 상담 바로가기
                    </LSRgBody01>
                    <img
                      src="/assets/icons/right_arrow.png"
                      alt="사전 상담 바로가기"
                      style={{
                        width: 4,
                        height: 8,
                      }}
                    />
                  </BannerButton>
                </BannerContentWrapper>
              </BannerContainer>

              <ContentWrapper>
                {isLoading ? (
                  <Loading />
                ) : applyList.length > 0 ? (
                  applyList.map((item) => (
                    <LectureWrapper
                      key={item.id}
                      onClick={() => {
                        navigate(`${route.consulting_detail}/${item.id}`);
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: isSmall ? "100px" : "308px",
                          borderRadius: 15,
                          overflow: "hidden",
                        }}
                      >
                        <LectureImg
                          src={
                            item?.thumbnailServerFileName
                              ? `${fileUrl}/${item.thumbnailServerFileName}`
                              : ""
                          }
                          alt="강의 이미지"
                        />
                      </div>
                      <LectureTextWrapper>
                        <LSRgH2HeadLine style={{ color: "#101113" }}>
                          {item.title}
                        </LSRgH2HeadLine>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 4,
                            height: 22,
                          }}
                        >
                          <img
                            style={{
                              width: 16,
                              height: 16,
                              marginBottom: 4,
                            }}
                            src={"/assets/icons/star_3d.png"}
                            alt="별점"
                          />
                          <LSRgH1HeadLine
                            style={{
                              marginTop: macOSCheck() ? 0 : 2,
                              color: "#6F7480",
                            }}
                          >
                            {Number(item.reviewScore ?? 0).toFixed(1)} (
                            {formatNumberWithCommas(item.reviewCount)})
                          </LSRgH1HeadLine>
                        </div>
                      </LectureTextWrapper>
                    </LectureWrapper>
                  ))
                ) : (
                  <Empty title="등록된 컨설팅이 없습니다." />
                )}
              </ContentWrapper>

              {!isLoading && applyList.length > 0 && (
                <Pagination
                  route={route.consulting_apply}
                  queryString={``}
                  currentPage={Number(page)}
                  totalPages={pagination.totalPages}
                  rangeSize={pagination.rangeSize}
                />
              )}
            </ContentContainer>
          </div>
        </PCContainer>
      )}

      {/* ******************************** */}
      {/* ********** 모바일 버전 ********** */}
      {/* ******************************** */}
      {isSmall && (
        <>
          <BannerContentWrapperMobile>
            <img
              src="/assets/images/consulting05_m.png"
              alt="사전 상담 바로가기 배너 이미지"
              style={{
                position: "absolute",
                width: "100%",
                height: 140,
              }}
            />
            <BannerTextWrapperMobile>
              <LSBdH2HeadLine style={{ color: "#fff" }}>
                사전 상담 받고
                <br />더 확실한 컨설팅을 받아보세요!
              </LSBdH2HeadLine>
              <LSRgCaption01 style={{ color: "#EDEDFF" }}>
                사전 상담을 통해 1:1 컨설팅 상품을 추천받고,
                <br />
                나에게 꼭 맞는 컨설팅 상품을 수강해 보세요.
              </LSRgCaption01>
            </BannerTextWrapperMobile>
          </BannerContentWrapperMobile>
          <MOContainer>
            <ContentContainer $isSmall={isSmall}>
              <ContentHeaderWrapper $isSmall={isSmall}>
                <LSRgH1HeadLine>📋 1:1 컨설팅</LSRgH1HeadLine>
                <SelectBox
                  style={{
                    width: "100%",
                  }}
                  subMenuStyle={{
                    width: "100%",
                  }}
                  isSmall={true}
                  isOpen={subMenuBoxOpen}
                  isLink={true}
                  selectedValue={selectedSubMenu}
                  wrapperHandler={() => {
                    setSubMenuBoxOpen(!subMenuBoxOpen);
                  }}
                  itemList={consultingTab}
                  selectedValueSetterFunc={setSelectedSubMenu}
                />
              </ContentHeaderWrapper>

              <ContentWrapper $isSmall={isSmall}>
                {isLoading ? (
                  <Loading />
                ) : applyList.length > 0 ? (
                  applyList.map((item) => (
                    <LectureWrapper
                      key={item.id}
                      $isSmall={isSmall}
                      onClick={() =>
                        navigate(`${route.consulting_detail}/${item.id}`)
                      }
                    >
                      <div
                        style={{
                          width: "100%",
                          height: isSmall ? "100px" : "308px",
                          borderRadius: 15,
                          overflow: "hidden",
                        }}
                      >
                        <LectureImg
                          $isSmall={isSmall}
                          src={
                            item?.thumbnailServerFileName
                              ? `${fileUrl}/${item.thumbnailServerFileName}`
                              : ""
                          }
                          alt="강의 이미지"
                        />
                      </div>
                      <LectureTextWrapper $isSmall={isSmall}>
                        <LSRgH1HeadLine style={{ color: "#101113" }}>
                          {item.title}
                        </LSRgH1HeadLine>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 4,
                            height: 22,
                          }}
                        >
                          <img
                            style={{
                              width: 16,
                              height: 16,
                              marginBottom: 4,
                            }}
                            src={"/assets/icons/star_3d.png"}
                            alt="별점"
                          />
                          <LSRgCaption02 style={{ color: "#6F7480" }}>
                            {Number(item.reviewScore ?? 0).toFixed(1)} (
                            {formatNumberWithCommas(item.reviewCount)})
                          </LSRgCaption02>
                        </div>
                      </LectureTextWrapper>
                    </LectureWrapper>
                  ))
                ) : (
                  <Empty title="등록된 컨설팅이 없습니다." />
                )}
              </ContentWrapper>

              {applyList.length > 0 && (
                <Pagination
                  style={{ marginTop: 24 }}
                  route={route.consulting_apply}
                  queryString={``}
                  currentPage={Number(page) || 1}
                  totalPages={pagination.totalPages}
                  rangeSize={pagination.rangeSize}
                />
              )}
            </ContentContainer>
          </MOContainer>
        </>
      )}
    </HomeSection>
  );
};

export default ConsultingApply;

const HomeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: ${(props) =>
    props.$isSmall ? "180px 0px 80px 0px" : "80px 0px 150px 0px"};
`;

const TabContainer = styled.div.attrs((props) => {})`
  width: 175px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ContentContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

const ContentHeaderWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$isSmall ? "16px" : "4px")};
  margin-bottom: ${(props) => (props.$isSmall ? "20px" : "30px")};
`;

const BannerContainer = styled.div.attrs((props) => {})`
  position: relative;
  width: 995px;
  height: 210px;
  margin-bottom: 30px;
  border-radius: 15px;
`;

const BannerContentWrapper = styled.div.attrs((props) => {})`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 895px;
  height: fit-content;
`;

const BannerContentWrapperMobile = styled.div.attrs((props) => {})`
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  width: 375px;
  height: 140px;
  display: flex;
  flex-direction: column;
`;

const BannerTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const BannerTextWrapperMobile = styled.div.attrs((props) => {})`
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 31px 20px;
`;

const BannerButton = styled.button.attrs((props) => {})`
  width: 149px;
  height: 40px;
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
`;

const ContentWrapper = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  display: flex;
  flex-wrap: wrap;
  column-gap: ${(props) => (props.$isSmall ? "19px" : "29px")};
  row-gap: ${(props) => (props.$isSmall ? "20px" : "30px")};
`;

const LectureWrapper = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "158px" : "483px")};
  min-height: ${(props) => (props.$isSmall ? "180px" : "375px")};
  display: flex;
  flex-direction: column;
  gap: 16px;
  cursor: pointer;

  border-radius: 15px;

  &:hover img {
    transform: scale(1.04); /* 이미지 확대 */
    transition:
      transform 0.3s ease-in-out,
      filter 0.3s ease; /* 부드러운 애니메이션 */
  }
`;

const LectureImg = styled.img.attrs((props) => {})`
  width: 100%;
  height: ${(props) => (props.$isSmall ? "100px" : "308px")};
  object-fit: cover;
  transition:
    transform 0.3s ease,
    filter 0.3s ease; /* 기본 상태의 애니메이션 */
  border-radius: 15px;
`;

const LectureTextWrapper = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "158px" : "483px")};
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
